import { render, staticRenderFns } from "./deliveryareaDone_new.vue?vue&type=template&id=12fc1e11&scoped=true"
import script from "./deliveryareaDone_new.vue?vue&type=script&lang=js"
export * from "./deliveryareaDone_new.vue?vue&type=script&lang=js"
import style0 from "./deliveryareaDone_new.vue?vue&type=style&index=0&id=12fc1e11&prod&lang=css"
import style1 from "./deliveryareaDone_new.vue?vue&type=style&index=1&id=12fc1e11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc1e11",
  null
  
)

export default component.exports